<template>
  <div class="m-4 md:mx-8 md:mt-16">
    <div class="flex flex-col md:flex-row md:items-center justify-between mb-4 space-y-2 md:space-y-0">
      <span class="font-semibold text-primario text-lg tracking-wide">
        {{ $t("lang.msg.escandallos") }}
      </span>
    </div>
      <div class="flex flex-col md:flex-col md:items-center justify-between mb-4 space-y-2 md:space-y-0 bg-white">
           <span
               class="font-semibold text-primario text-lg tracking-wide bg-gray-600 p-2 text-white w-full"
               style="color: white"
           >
               Filtros
          </span>
          <div class="flex w-full justify-around">
              <div class="w-1/4">
                  <div class=" w-full mb-2">
                      <InputWrapper :block="true" :label="'Referencia'" content="input">
                          <InputText v-model="filters.referencia"/>
                      </InputWrapper>
                  </div>
                  <div class=" w-full mb-2">
                      <InputWrapper :block="true" :label="'Cliente'" content="input">
                          <Select
                              id="idClient"
                              :data="clients"
                              track-by="clientName"
                              v-model.number="filters.idClient"
                          />
                      </InputWrapper>
                  </div>
                  <div class=" w-full mb-2">
                      <InputWrapper :block="true" :label="'Departamento'" content="input">
                          <Select
                              id="idSection"
                              :data="departments"
                              track-by="sectionName"
                              v-model.number="filters.idSection"
                          />
                      </InputWrapper>
                  </div>
              </div>
              <div class="w-1/4">
                  <div class=" w-full mb-2">
                      <InputWrapper :block="true" :label="'Colección'" content="input">
                          <Select
                              id="idCollection"
                              :data="collections"
                              track-by="collectionEs"
                              v-model.number="filters.idCollection"
                          />
                      </InputWrapper>
                  </div>
                  <div class=" w-full mb-2">
                      <InputWrapper :block="true" :label="'Fábrica'" content="input">
                          <Select
                              id="idFactory"
                              :data="factories"
                              track-by="factoryName"
                              v-model.number="filters.idFactory"
                          />
                      </InputWrapper>
                  </div>
                  <div class=" w-full mb-2 mt-6" >
                      <ToggleButton :checked="filters.definitivo" >
                          Definitivo
                      </ToggleButton>
                  </div>
              </div>
              <div class="w-1/4 bg-white p-2 flex flex-col" style="justify-content: center">
                  <ButtonAction @action="applyFilters" large>
                      Aplicar filtros
                  </ButtonAction>
              </div>
          </div>
      </div>
      <datatable
      :data="escandallos"
      :headers="headers"
      @on-row-click="redirectoToView"
      hover-field="caracteristicas"
    />
  </div>
</template>

<script>
import DataTable from "@/components/shared/DataTable";

export default {
  name: "Escandallos",
  components: {
    datatable: DataTable
  },
  data() {
    return {
      idComercialRequest: 0,
      escandallos: [],
        clients:[],
        departments:[],
        collections:[],
        factories:[],
      headers: {
        referencia: "Referencia EP",
        clientName: "Cliente",
        departmentName: "Dpto",
        collectionName: "Colección",
        fecha: {
          name: "Fecha",
          type: Date
        },
        fabrica: "Fábrica",
        origen: "Origen fábrica",
        precioCompra: "Precio compra a fábrica",
        precioVenta: "Precio venta a cliente",
        definitivo: {
          name: "Definitivo",
          type: Boolean
        }
      },
      filters:{}
    };
  },
  created() {
    this.idComercialRequest = this.$route.params.idComercialRequest;

    this.fetchEscandallo();
  },
  methods: {
      applyFilters(){
          let axiosEscandallo = "";
          const filterClone = JSON.parse(JSON.stringify(this.filters));
          axiosEscandallo = this.$axios.post(`api/Escandalloes/GetFilteredSend`, filterClone);
          Promise.all([
              axiosEscandallo
          ]).then(values => {
              this.escandallos = values[0].data;
          })
      },
    fetchEscandallo() {
        let langParams = {
            lang: this.language
        };
          Promise.all([
              this.$axios.get(`api/Clients/GetAllClient`),
              this.$axios.get(`api/Sections/getSection`),
              this.$axios.post(`api/Collections/GetCollectionActive`, langParams),
              this.$axios.get(`api/DocumentCertificats/ComboFactory`)
          ]).then(values=>{
              this.clients = values[0].data
              this.departments = values[1].data
              this.collections = values[2].data
              this.factories = values[3].data
          })
      if (this.idComercialRequest === undefined) {
        this.$axios.get(`api/Escandalloes/GetAllReal`).then((response) => {
          this.escandallos = response.data;
        });
      } else {
        this.$axios
          .post(`api/Escandalloes/GetAll`, {
            idComercialRequest: parseInt(this.idComercialRequest)
          })
          .then((response) => {
            this.escandallos = response.data;
          });
      }
    },
    redirectoToView(item) {
      if (this.hasRoles(['ADMIN', 'DIRECCIÓN']))  {
        this.$router.push({ name: "escandalloDetail", params: { idEscandallo: item.idEscandallo }});
      }
    }
  }
};
</script>
